export function ReportsPage() {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6">
      <div className="text-xl font-semibold text-slate-900">Relatórios</div>
      <div className="mt-2 text-sm text-slate-500">
        Em breve: relatórios por empresa (funcionários, custos, rescisões) com exportação.
      </div>
    </div>
  )
}

